import { gql } from '@apollo/client';

export const TALENT_LANGUAGE_FRAGMENT = gql`
    fragment talentLanguageFragment on TalentLanguage {
        _id
        talentId
        languages {
            languageId
            levelId
            certificateLanguges
        }
    }
`;

export const ADD_TALENT_LANGUAGE = gql`
    ${TALENT_LANGUAGE_FRAGMENT}
    mutation AddTalentLanguage($request: RequestTalentLanguage) {
        addTalentLanguage(request: $request) {
            ...talentLanguageFragment
        }
    }
`;

export const UPDATE_TALENT_LANGUAGE = gql`
    ${TALENT_LANGUAGE_FRAGMENT}
    mutation UpdateTalentLanguage($request: RequestTalentLanguage) {
        updateTalentLanguage(request: $request) {
            ...talentLanguageFragment
        }
    }
`;

export const DELETE_TALENT_LANGUAGE = gql`
    ${TALENT_LANGUAGE_FRAGMENT}
    mutation DeleteTalentLanguage($id: ID!) {
        deleteTalentLanguage(id: $id) {
            ...talentLanguageFragment
        }
    }
`;

const LANGUAGE_FRAGMENT = gql`
    fragment LanguageFragment on Language {
        _id
        code
        original_letter
        name
    }
`;

const LEVEL_LANGUAGE_FRAGMENT = gql`
    fragment LevelLanguageFragment on LevelLanguage {
        _id
        level
        score
    }
`;

export const GET_DATA_TRANSFORM_LANGUAGE = gql`
    query GetAllLevelLanguage {
        getDataTransformLanguage {
            language {
                ...LanguageFragment
            }
            levelLanguage {
                ...LevelLanguageFragment
            }
        }
    }
    ${LANGUAGE_FRAGMENT}
    ${LEVEL_LANGUAGE_FRAGMENT}
`;

export const GET_DATA_LANGUAGE_PAGINATION = gql`
    query GetWithPagination($pagination: Pagination, $sortBy: String, $query: String) {
        getWithPagination(pagination: $pagination, sortBy: $sortBy, query: $query) {
            docs {
                ...LanguageFragment
            }
            meta {
                totalDocs
                limit
                page
                nextPage
                prevPage
                totalPages
                hasPrevPage
                hasNextPage
                pagingCounter
            }
        }
    }
    ${LANGUAGE_FRAGMENT}
`;

export const GET_ALL_LANGUAGE = gql`
    query GetAllLanguage {
        getAllLanguage {
            ...LanguageFragment
        }
    }
    ${LANGUAGE_FRAGMENT}
`;
